import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import {organisationDetails, saveOrUpdateOrganisationDetails, exportReport} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import MuiTable from "../common/MuiTable";
import {compareStrings} from "../../util/CommonUtils";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

function createData(name, description, immutable) {
    return { name, description, immutable };
}

function isEnglishUser(currentUser) {
    const lang = currentUser && currentUser.language ? String(currentUser.language).toLowerCase() : '';
    return lang.startsWith('en');
}

function getDefaultRows(currentUser) {
    if (!isEnglishUser(currentUser)) {
        return [];
    }
    return [
        createData(t('context.terms.defaults.competence.term'), t('context.terms.defaults.competence.definition'), true),
        createData(t('context.terms.defaults.contract.term'), t('context.terms.defaults.contract.definition'), true),
        createData(t('context.terms.defaults.correctiveAction.term'), t('context.terms.defaults.correctiveAction.definition'), true),
        createData(t('context.terms.defaults.environment.term'), t('context.terms.defaults.environment.definition'), true),
        createData(t('context.terms.defaults.ims.term'), t('context.terms.defaults.ims.definition'), true),
        createData(t('context.terms.defaults.objective.term'), t('context.terms.defaults.objective.definition'), true),
        createData(t('context.terms.defaults.consultation.term'), t('context.terms.defaults.consultation.definition'), true),
        createData(t('context.terms.defaults.workplace.term'), t('context.terms.defaults.workplace.definition'), true),
        createData(t('context.terms.defaults.contractor.term'), t('context.terms.defaults.contractor.definition'), true),
        createData(t('context.terms.defaults.requirement.term'), t('context.terms.defaults.requirement.definition'), true),
        createData(t('context.terms.defaults.legalRequirements.term'), t('context.terms.defaults.legalRequirements.definition'), true),
        createData(t('context.terms.defaults.managementSystem.term'), t('context.terms.defaults.managementSystem.definition'), true),
        createData(t('context.terms.defaults.topManagement.term'), t('context.terms.defaults.topManagement.definition'), true),
        createData(t('context.terms.defaults.effectiveness.term'), t('context.terms.defaults.effectiveness.definition'), true),
        createData(t('context.terms.defaults.ohsPolicy.term'), t('context.terms.defaults.ohsPolicy.definition'), true),
        createData(t('context.terms.defaults.hazard.term'), t('context.terms.defaults.hazard.definition'), true),
        createData(t('context.terms.defaults.documentedInformation.term'), t('context.terms.defaults.documentedInformation.definition'), true),
        createData(t('context.terms.defaults.process.term'), t('context.terms.defaults.process.definition'), true),
        createData(t('context.terms.defaults.procedure.term'), t('context.terms.defaults.procedure.definition'), true),
        createData(t('context.terms.defaults.outsource.term'), t('context.terms.defaults.outsource.definition'), true),
        createData(t('context.terms.defaults.audit.term'), t('context.terms.defaults.audit.definition'), true),
        createData(t('context.terms.defaults.nonconformity.term'), t('context.terms.defaults.nonconformity.definition'), true),
    ];
}

const muiColumns = [
    { title: t('context.terms.term'), field: 'name'},
    { title: t('context.terms.definition'), field: 'description', headerStyle: { width: "50%" } },
];

class TermsAndDefinitions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            organisation: null,
            orgId: "",
            termsAndDefinitions: [],
            isLoading: true,
        };

        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.export = this.export.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                let merged = response.termsAndDefinitions.concat(getDefaultRows(this.props.currentUser)).sort(function(a, b) {
                    return compareStrings(a.name, b.name);
                });
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    termsAndDefinitions: merged,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('acronyms.validation.message'), 5000);
        }
        return isValid;
    }

    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.termsAndDefinitions.length; i < l; i++) {
            if (this.state.organisation.termsAndDefinitions[i].id === toUpdate.id) {
                this.state.organisation.termsAndDefinitions[i].name = toUpdate.name;
                this.state.organisation.termsAndDefinitions[i].description = toUpdate.description;
            }
        }
        console.log("After update:", this.state.organisation.termsAndDefinitions);
        this.handleSubmit(this.state.organisation.termsAndDefinitions);
    }

    handleDelete(toDelete) {
        let termsAndDefinitions = [];
        const index = this.state.organisation.termsAndDefinitions.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.termsAndDefinitions.length; i < l; i++) {
            if (i !== index) {
                termsAndDefinitions.push(this.state.organisation.termsAndDefinitions[i]);
            }
        }
        console.log("After removal:", termsAndDefinitions);
        this.handleSubmit(termsAndDefinitions);
    }

    handleAdd(data) {
        this.state.organisation.termsAndDefinitions.push(data);
        this.handleSubmit(this.state.organisation.termsAndDefinitions);
    }

    handleSubmit(data) {
        this.state.organisation.termsAndDefinitions = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
                this.loadOrganisationDetails();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    export() {
        exportReport('/organisation/export/TERMS_AND_DEFINITIONS');
    }

    render() {
        let { isLoading } = this.state;
        if (isLoading) {
            return null;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                {t('context.terms.title')}
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <MuiTable
                    title={t('context.terms.title')}
                    columns={muiColumns}
                    data={this.state.termsAndDefinitions}
                    onAdd={this.handleAdd}
                    onUpdate={this.handleUpdate}
                    onDelete={this.handleDelete}
                    isValid={this.isValid}
                    exportButton={!isDemo && !isViewer}
                    onExport={this.export}
                    allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                    pageSize={10}
                />
            </Paper>
            <NotificationContainer/>
        </div>
        ;
    }
}

export default withStyles(classes)(TermsAndDefinitions);